<template>
  <div>
    <slot :openModal="openModal"></slot>
    <b-modal size="xl" title="Add plan" hide-footer v-model="showModal">
      <onboarding-popup-payment-modal-container/>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    }
  },

  methods: {
    openModal() {
      this.showModal = true
    },
  }
}
</script>